import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

export class PayscaleEntriesCard extends Component {
  handleFormChange = (event) => {
    const { name, value } = event.target;
    const { index, entry } = this.props;
    let updatedEntry = { ...entry };
    updatedEntry = {
      ...updatedEntry,
      [name]: value,
    };
    this.props.onUpdateEntry(updatedEntry, index);
  };

  render() {
    const { 
      entry = {},
      index,
      deleteEntry,
      payLevelOptions
    } = this.props;

    const {
      level,
      basicWage,
      ecola,
      monthlyWage,
      dailyRate,
    } = entry;


    return (
      <Card
        hideFooter
        key={"xxx"}
        title={`Entry`}
        content={
          <Row>
            <Col sm={12} md={2}>
              <FormGroup>
                <ControlLabel>Level</ControlLabel>
                <FormControl 
                  onChange={this.handleFormChange}
                  componentClass="select" 
                  name="level"
                  value={level}
                >
                  <option value="">Select</option>
                  {payLevelOptions.map(option => {
                    return (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </FormControl>
              </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                  <ControlLabel>Basic Wage</ControlLabel>
                  <FormControl
                    type="text"
                    name="basicWage"
                    value={basicWage}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                  <ControlLabel>ECOLA</ControlLabel>
                  <FormControl
                    type="text"
                    name="ecola"
                    value={ecola}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                  <ControlLabel>Monthly Wage</ControlLabel>
                  <FormControl
                    type="text"
                    name="monthlyWage"
                    value={monthlyWage}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
            </Col>
            <Col sm={12} md={3}>
              <div className="rule-actions">
                <FormGroup style={{ width: "100%" }}>
                  <ControlLabel>Daily Rate</ControlLabel>
                  <FormControl
                    type="text"
                    name="dailyRate"
                    value={dailyRate}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                {index !== 0 ? (
                  <i
                    className="pe-7s-trash"
                    onClick={() => deleteEntry(index)}
                  />
                ) : null}
              </div>
            </Col>
          </Row>
        }
      />
    );
  }
}

export default PayscaleEntriesCard;
